import Vue from 'vue'
import App from './App'
import router from './router'
import axios from './api'
import api from './api/api'

/* swiper */
import 'swiper/dist/css/swiper.min.css'

/* 重置样式 */
import './assets/css/reset.min.css'

/* bootstrap */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'

/* AOS 滚动动画 */
import AOS from 'aos'
import 'aos/dist/aos.css'

/* Font Awesome（CDN 方式在 index.html 引入，这里做备用） */

Vue.prototype.http = axios
Vue.prototype.api = api

/* 全局组件 */
import Header from './components/Header'
import Footer from './components/Footer'
import GoTop from './components/GoTop'
import PageBanner from './components/PageBanner'

Vue.component(Header.name, Header)
Vue.component(Footer.name, Footer)
Vue.component(GoTop.name, GoTop)
Vue.component('page-banner', PageBanner)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) document.title = to.meta.title
  next()
})

AOS.init({ duration: 800, once: true, offset: 60 })

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js